export const PUBLIC_USERNAME = "demo";
export const PUBLIC_PASSWORD = "demo";
// export const PUBLIC_USERNAME = "neo4juser";
// export const PUBLIC_PASSWORD = "Iru@90361";
export const GENIEBOARD_USER_ID = "genieboard-user-id";

export const PUBLIC_DATABASE = "plantgenie";

export const GENIELIST_DATABASE = "plantgenie";

export const GENIEBOARD_THEMES = [
  {
    name: "Green",
    primary: "#9ebf6d",
    index: 0,
  },
  {
    name: "Dark",
    primary: "#323447",
    index: 1,
  },
];

export const NO_QUERY_REPORTS = [
  "heatMap",
  "enrichmentChart",
  "blast",
  "jbrowse",
  "exImage",
];

export const NO_NO_DATA_SHOW_REPORTS = ["graphCytoscapeJS"];

export const EX_IMAGE_SAMPLE_MAP = [
  {
    key: "aspwood--wood--",
    replace: "",
  },
  {
    key: "sex--leaf--",
    replace: "",
  },
  {
    key: "202--NA",
    replace: "ERS235757",
  },
  {
    key: "207--NA",
    replace: "ERS235758",
  },
  {
    key: "213.1--NA",
    replace: "ERS235759",
  },
  {
    key: "221--NA",
    replace: "ERS235760",
  },
  {
    key: "226.1--NA",
    replace: "ERS235761",
  },
  {
    key: "229.1--NA",
    replace: "ERS235762",
  },
  {
    key: "229--NA",
    replace: "ERS235763",
  },
  {
    key: "235--NA",
    replace: "ERS235764",
  },
  {
    key: "236--NA",
    replace: "ERS235765",
  },
  {
    key: "239--NA",
    replace: "ERS235766",
  },
  {
    key: "244--NA",
    replace: "ERS235767",
  },
  {
    key: "303--NA",
    replace: "ERS235768",
  },
  {
    key: "305.3--NA",
    replace: "ERS235769",
  },
  {
    key: "309.1--NA",
    replace: "ERS235770",
  },
  {
    key: "310.3--NA",
    replace: "ERS235771",
  },
  {
    key: "337.1--NA",
    replace: "ERS235772",
  },
  {
    key: "349.2--NA",
    replace: "ERS235773",
  },
  {
    key: "alidhem--NA",
    replace: "alidhem",
  },
  {
    key: "ersboda--NA",
    replace: "ersboda",
  },
  {
    key: "sculPark--NA",
    replace: "sculPark",
  },
  {
    key: "xylem_leaf--",
    replace: "",
  },
  {
    key: "Z4006TR23",
    replace: "night_needles",
  },
  {
    key: "Z4006TR22",
    replace: "late_afternoon_needles",
  },
  {
    key: "Z4006TR08",
    replace: "pineapple_galls",
  },
  {
    key: "Z4006TR05",
    replace: "infected_needles",
  },
  {
    key: "Z4006TR11",
    replace: "needles_from_veg_shoots_z4006tr11",
  },
  {
    key: "Z4006TR04",
    replace: "needles_2008_z4006tr04",
  },
  {
    key: "Z4006TR03",
    replace: "needles_2009_z4006tr03",
  },
  {
    key: "Z4006TR18",
    replace: "needles_from_girled_twig_z4006tr18",
  },
  {
    key: "Z4006TR21",
    replace: "mid_day_needles_z4006tr21",
  },
  {
    key: "Z4006TR20",
    replace: "early_morning_needles_z4006tr20",
  },
  {
    key: "Z4006TR01",
    replace: "male_cone_z4006tr01",
  },
  {
    key: "Z3001TR10",
    replace: "female_cone_z4006tr10",
  },
  {
    key: "Z4006TR16",
    replace: "needles_from_dried_twig_z4006tr16",
  },
  {
    key: "Z4006TR15",
    replace: "buds_late_season_developed_z4006tr15",
  },
  {
    key: "Z4006TR09",
    replace: "buds_early_season_developed_z4006tr09",
  },
  {
    key: "Z4006TR19",
    replace: "stem_from_girdled_twig_z4006tr19",
  },
  {
    key: "Z4006TR12",
    replace: "stem_from_vegetative_shoots_z4006tr12",
  },
  {
    key: "Z4006TR02",
    replace: "vegetative_shoots_z4006tr02",
  },
  {
    key: "Z4006TR07",
    replace: "vegetative_shoots_z4006tr07",
  },
  {
    key: "Z4006TR24",
    replace: "wood_z4006tr24",
  },
  {
    key: "Z4006TR25",
    replace: "wood_z4006tr25",
  },
];
